import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const OPTIONAL_COLUMN_IDS = [
  "invoice_amount",
  "invoice_date",
  "invoice_number",
];

interface InitState {
  optionalColumnIds: string[];
  selectedOptionalColumnsIds: string[];
}

const initialState: InitState = {
  optionalColumnIds: OPTIONAL_COLUMN_IDS,
  selectedOptionalColumnsIds: [],
};

export const inboxTableSlice = createSlice({
  name: "inboxTable",
  initialState,
  reducers: {
    setHiddenColumnIds: (
      state: InitState,
      action: PayloadAction<string[]>
    ): void => {
      state.selectedOptionalColumnsIds = action.payload;
    },
  },
});

export const { setHiddenColumnIds } = inboxTableSlice.actions;

export default inboxTableSlice.reducer;
